
import React from "react";
import { Button } from "@/components/ui/button";
import { useLeadCapture } from "@/hooks/useLeadCapture";

interface TocFotosCTAProps {
  onButtonClick: () => void;
}

const TocFotosCTA: React.FC<TocFotosCTAProps> = ({
  onButtonClick
}) => {
  const { openLeadCapture, LeadCaptureModalComponent } = useLeadCapture({
    title: "Solicitar orçamento",
    description: "Preencha seus dados para receber seu orçamento",
    source: "TocFotos CTA",
    onSuccess: () => {
      onButtonClick();
    }
  });

  return (
    <>
      {LeadCaptureModalComponent}
      <div className="container max-w-7xl mx-auto px-4 text-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Quer ver quanto fica o seu imóvel?
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto mb-10">Fale conosco e receba seu orçamento</p>
          <div className="inline-block">
            <Button 
              onClick={() => openLeadCapture()} 
              size="lg" 
              className="bg-white text-[#3332FC] hover:bg-white/90 rounded-full px-8 py-6 text-lg font-medium"
            >
              Solicitar Orçamento
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TocFotosCTA;
